<template>
  <b-row>
    <b-col md="12" v-if="selectedTags.length > 0 || !disableFields">
      <p class="mb-n1" @click="enableEdit = !enableEdit">
        {{ $t('tags') }}
        <i v-if="!enableEdit && !disableFields" class="fa fa-angle-down"></i>
        <i v-if="enableEdit && !disableFields" class="fa fa-angle-up"></i>
      </p>
      <b-form-group>
        <b-row>
          <b-col md="12">
            <span
                class="mr-1 mb-1"
                v-bind:key="tag.id"
                v-for="tag in selectedTags">
              <b-badge :style="'background-color:' + tag.color">
                {{ tag.name }}
              </b-badge>
              <b-badge variant="danger" v-if="!disableFields" style="cursor: pointer" @click="removeTag(tag)">
                x
              </b-badge>
            </span>
          </b-col>
        </b-row>
        <b-row v-if="!disableFields && enableEdit">
          <b-col md="6">
            <p class="mb-n1">{{ $t("chooseTag") }}</p>
            <b-form-select @change="onOptionClick" v-model="selectedTag">
              <template slot="first">
                <option value="create">- {{ $t("createNewTag") }} - </option>
              </template>
              <b-form-select-option v-for="tag in availableTags" :key="tag.id" :value="tag">
                {{ tag.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col md="6" v-if="showAddNewTag">
            <p class="mb-n1">{{ $t("createNewTag") }}:</p>
            <b-form-input v-model="newTag.name" type="text" :disabled="disableFields"></b-form-input>
            <b-button
              variant="success"
              @click="createTag()"
              :disabled="loading > 0"
              v-if="!disableFields && newTag.name"
            >
              <strong class="ml-2">{{ $t("add") }}</strong>
              <span class="icon">
                <i class="fa fa-plus"></i>
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-col>
    <b-col md="12" v-if="$user.shallSeeModule('reports') && (selectedEsrsTags && selectedEsrsTags.length > 0 || !disableFields)">
      <p class="mb-n1" @click="enableEsrsEdit = !enableEsrsEdit">
        ESRS {{ $t('tags') }}
        <i v-if="!enableEsrsEdit && !disableFields" class="fa fa-angle-down"></i>
        <i v-if="enableEsrsEdit && !disableFields" class="fa fa-angle-up"></i>
      </p>
      <b-form-group>
        <b-row>
          <b-col md="12">
            <span
                class="mr-1 mb-1"
                v-bind:key="tag.id"
                v-for="tag in selectedEsrsTags">
              <b-badge :style="'background-color:' + tag.color">
                {{ tag.name }}
              </b-badge>
              <b-badge variant="danger" v-if="!disableFields" style="cursor: pointer" @click="removeEsrsTag(tag)">
                x
              </b-badge>
            </span>
          </b-col>
        </b-row>
        <b-row v-if="!disableFields && enableEsrsEdit">
          <b-col md="6">
            <p class="mb-n1">{{ $t("chooseTag") }}</p>
            <b-form-select @change="onOptionClickEsrs" v-model="selectedEsrsTag">
              <b-form-select-option v-for="tag in availableEsrsTags" :key="tag.id" :value="tag">
                {{ tag.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import TagService from "@/services/TagService";
import Tag from "@/models/Tag";

export default {
  name: "TagSelector",
  components: {},
  data() {
    return {
      loading: 0,
      selectedTags: this.p_selectedTags,
      selectedEsrsTags: this.p_selectedEsrsTags ? this.p_selectedEsrsTags : [],
      allTags: [],
      allEsrsTags: [],
      disableFields: this.p_disableFields,
      newTag: new Tag({}),
      enableEdit: false,
      enableEsrsEdit: false,
      showAddNewTag: false,
      selectedTag: null,
      selectedEsrsTag: null
    };
  },
  validations: {},
  props: {
    p_disableFields: {
      type: Boolean,
      required: true,
      default: true
    },
    p_selectedTags: {
      type: Array,
      required: true,
      default: null
    },
    p_selectedEsrsTags: {
      type: Array,
      required: false,
      default: null
    },
    p_readOnly: false
  },
  watch: {
    p_selectedTags(tags) {
      this.selectedTags = tags;
    },
    p_selectedEsrsTags(tags) {
      this.selectedEsrsTags = tags;
    },
    p_disableFields(disable) {
      this.disableFields = disable;
    },
    selectedTags(tags) {
      this.$emit("tagsUpdated", tags);
    },
    selectedEsrsTags(tags) {
      this.$emit("tagsUpdated2", tags);
    }
  },
  mounted() {
    this.getTags();
    this.getEsrsTags();
  },
  computed: {
    availableTags() {
      return this.allTags.filter((tag) => {
        return !this.selectedTags.find((x) => {
          return x.id == tag.id;
        });
      });
    },
    availableEsrsTags() {
      return this.allEsrsTags.filter((tag) => {
        return !this.selectedEsrsTags.find((x) => {
          return x.id == tag.id;
        });
      });
    }
  },
  methods: {
    onOptionClick(tag) {
      if(tag == "create")
      {
        this.showAddNewTag = true;
      }
      else if(tag)
      {
        this.selectedTag = null;
        this.addTag(tag);
      }
    },
    onOptionClickEsrs(tag) {
      if(tag)
      {
        this.selectedEsrsTag = null;
        this.addEsrsTag(tag);
      }
    },
    getTags() {
      this.loading++;
      TagService.getTagsByCompany(this.$userSelectedCompanyId(), 1, 200, "").then((response) => {
        this.allTags = response.results;
        this.showAddNewTag = false;
        this.selectedTag = null;
        this.loading--;
      });
    },
    getEsrsTags() {
      this.loading++;
      TagService.getEsrsTags().then((response) => {
        this.allEsrsTags = response;
        this.selectedEsrsTag = null;
        this.loading--;
      });
    },
    removeTag(tag) {
      var index = this.selectedTags.findIndex((d) => {
        return d.id == tag.id;
      });

      this.selectedTags.splice(index, 1);
      this.showAddNewTag = false;
      this.selectedTag = null;
    },
    addTag(tag) {
      this.selectedTags.push(tag);
      this.showAddNewTag = false;
      this.selectedTag = null;
    },
    removeEsrsTag(tag) {
      var index = this.selectedEsrsTags.findIndex((d) => {
        return d.id == tag.id;
      });

      this.selectedEsrsTags.splice(index, 1);
      this.selectedEsrsTag = null;
    },
    addEsrsTag(tag) {
      this.selectedEsrsTags.push(tag);
      this.selectedEsrsTag = null;
    },
    createTag() {
      this.loading++;
      TagService.createCompanyTag(this.$userSelectedCompanyId(), this.newTag).then(() => {
        this.newTag = new Tag({});
        this.loading--;
        this.getTags();
      });
    }
  }
};
</script>
<style scoped>
</style>
